import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useMemo } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import { calcPrecentage } from "./ElectionEventStats";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { useTranslation } from "react-i18next";
var useTallyStats = function (props) {
    var electionsCount = props.electionsCount, startCountingVotesCount = props.startCountingVotesCount, notStartCountingVotesCount = props.notStartCountingVotesCount, genereatedTallyCount = props.genereatedTallyCount, notGenereatedTallyCount = props.notGenereatedTallyCount, transmissionStats = props.transmissionStats;
    var t = useTranslation().t;
    var authContext = useContext(AuthContext);
    var showPostsStartCounting = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_POSTS_ALREADY_STARTED_COUNTING_VOTES);
    var showPostsGeneratedER = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_POSTS_ALREADY_GENERATED_ELECTION_RESULTS);
    var showPostsTransmittedResults = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_POSTS_TRANSMITTED_RESULTS);
    var tallySection = useMemo(function () {
        return {
            show: showPostsStartCounting || showPostsGeneratedER || showPostsTransmittedResults,
            title: t("monitoringDashboardScreen.tally.title"),
            stats: [
                {
                    show: showPostsStartCounting,
                    title: t("monitoringDashboardScreen.tally.activeVotesCounting"),
                    items: [
                        {
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: startCountingVotesCount,
                            percentage: calcPrecentage(startCountingVotesCount, electionsCount),
                        },
                        {
                            icon: _jsx(CancelOutlinedIcon, {}),
                            count: notStartCountingVotesCount,
                            percentage: calcPrecentage(notStartCountingVotesCount, electionsCount),
                        },
                    ],
                },
                {
                    show: showPostsGeneratedER,
                    title: t("monitoringDashboardScreen.tally.generatedERs"),
                    items: [
                        {
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: genereatedTallyCount,
                            percentage: calcPrecentage(genereatedTallyCount, electionsCount),
                        },
                        {
                            icon: _jsx(CancelOutlinedIcon, {}),
                            count: notGenereatedTallyCount,
                            percentage: calcPrecentage(notGenereatedTallyCount, electionsCount),
                        },
                    ],
                },
                {
                    show: showPostsTransmittedResults,
                    title: t("monitoringDashboardScreen.tally.transmittedResults"),
                    items: [
                        {
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: transmissionStats.transmittedCount,
                            percentage: calcPrecentage(transmissionStats.transmittedCount, electionsCount),
                        },
                        {
                            icon: _jsx(HourglassEmptyOutlinedIcon, {}),
                            count: transmissionStats.halfTransmittedCount,
                            percentage: calcPrecentage(transmissionStats.halfTransmittedCount, electionsCount),
                        },
                        {
                            icon: _jsx(CancelOutlinedIcon, {}),
                            count: transmissionStats.notTransmittedCount,
                            percentage: calcPrecentage(transmissionStats.notTransmittedCount, electionsCount),
                        },
                    ],
                },
            ],
        };
    }, [
        showPostsStartCounting,
        showPostsGeneratedER,
        showPostsTransmittedResults,
        electionsCount,
        transmissionStats,
        showPostsTransmittedResults,
        notGenereatedTallyCount,
        genereatedTallyCount,
        showPostsGeneratedER,
        startCountingVotesCount,
        notStartCountingVotesCount,
    ]);
    return { tallySection: tallySection };
};
export default useTallyStats;
